// extracted by mini-css-extract-plugin
module.exports = {"buttonSettings":"IntegrationDetailsHeaderContent_buttonSettings__IB5yQ","buttonProjects":"IntegrationDetailsHeaderContent_buttonProjects__nDXuA"};